export default __webpack_public_path__ + "static/media/img-slider-om-wallet-4.22a8c327.png";